import * as React from 'react';
import { SVGProps } from 'react';

const CrownYellow = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 576" {...props}>
    <path
      d="M309 138C320.4 131 328 118.3 328 104C328 81.9 310.1 64 288 64C265.9 64 248 81.9 248 104C248 118.4 255.6 131 267 138L209.7 252.6C200.6 270.8 177 276 161.1 263.3L72 192C77 185.3 80 177 80 168C80 145.9 62.1 128 40 128C17.9 128 0 145.9 0 168C0 190.1 17.9 208 40 208C40.2 208 40.5 208 40.7 208L86.4 459.4C91.9 489.8 118.4 512 149.4 512H426.6C457.5 512 484 489.9 489.6 459.4L535.3 208C535.5 208 535.8 208 536 208C558.1 208 576 190.1 576 168C576 145.9 558.1 128 536 128C513.9 128 496 145.9 496 168C496 177 499 185.3 504 192L414.9 263.3C399 276 375.4 270.8 366.3 252.6L309 138Z"
      fill="#FED00B"
    />
  </svg>
);

export default CrownYellow;
